import { MESSAGE_ERROR, MESSAGE_SUCCESS, MESSAGE_WARNING } from 'core/redux/types';
import { GoogleAuth, menuItens } from 'features';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { history, removeMessage } from 'utils';
import * as TYPES from './types';

class HeaderComponent extends React.Component<TYPES.StateProps> {
  state = {
    pageTitle: '',
  };

  componentDidMount() {
    history.listen(this.updatePageTitle);
    this.updatePageTitle();
  }

  updatePageTitle = () => {
    const { pathname } = history.location;
    const menu = _.find(menuItens, ['route', pathname]);
    const pageTitle = menu ? menu.name : '';
    if (this.state.pageTitle !== pageTitle) {
      this.setState({ pageTitle });
    }
  };

  showMessage() {
    const { description, type = '' } = this.props.message;
    if (this.props.message.description !== '') {
      switch (type) {
        case MESSAGE_ERROR:
          toast.error(description);
          break;
        case MESSAGE_SUCCESS:
          toast.success(description);
          break;
        case MESSAGE_WARNING:
          toast.warn(description);
          break;
        default:
          toast(description);
      }
      removeMessage();
    }
  }

  renderAvatar() {
    const { user, isSignedIn } = this.props.auth;
    if (!isSignedIn || !user || !user.photoURL || !user.displayName) {
      return;
    }

    const { photoURL, displayName } = user;
    return (
      <div className='ui item'>
        <img className='ui image avatar' src={photoURL} alt={displayName} />
        <span>{displayName}</span>
      </div>
    );
  }

  render() {
    this.showMessage();

    return (
      <div className='ui secondary menu header-container'>
        <div className='item'>
          <h3>{this.state.pageTitle}</h3>
        </div>
        <div className='right menu'>
          <div className='ui item'>
            <GoogleAuth />
          </div>
          {this.renderAvatar()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, message }: TYPES.StateProps) => ({
  auth,
  message,
});

export const Header = connect(mapStateToProps)(HeaderComponent);
